import activityModal from './activityModal';

export default activityModal;